module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/user/admin/shared/admin-form/admin-form.component.scss
// module id = ./src/app/user/admin/shared/admin-form/admin-form.component.scss
// module chunks = main